import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';

@Component({
  selector: 'lib-ds-notice',
  templateUrl: './notice.component.html',
  styleUrls: ['./notice.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DsNoticeComponent {
  @Input() message: string = '';
  @Input() type: 'error' | 'success' | 'message' = 'message';
  @Output() dismiss = new EventEmitter<void>();
  @Input() hideClose = false;
  onDismiss(): void {
    this.dismiss.emit();
  }
}
